import React from 'react';
import {useNavigate} from 'react-router-dom';
import '../styles/HomePage.css';

function ContactPage(){

  const navigate=useNavigate();

  return(

    <div className="homepage-container">

      <section className="workforce-hero fade-in">

        <div className="hero-content">

          <p className="eyebrow">
            Contact AXU Workforce
          </p>

          <h1>
            We're Here To Help
          </h1>

          <p>
            Whether you're looking for work or need reliable workers,
            our recruitment team is ready to assist.
          </p>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-grid">

          <div className="feature-card">

            <h3>📧 Email</h3>

            <p>
              <a href="mailto:info@axuworkforce.co.uk">info@axuworkforce.co.uk</a>
            </p>

          </div>

          <div className="feature-card">

            <h3>🕒 Office Hours</h3>

            <p>

              Monday – Friday

              <br/><br/>

              08:00 – 18:00

              <br/><br/>

              Saturday

              <br/>

              09:00 – 13:00

            </p>

          </div>

          <div className="feature-card">

            <h3>📍 Coverage</h3>

            <p>

              Supplying temporary and permanent workers
              throughout the United Kingdom.

            </p>

          </div>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="hero-actions">

          <button
            className="primary-btn"
            onClick={()=>navigate('/quote')}
          >
            Apply for Work
          </button>

          <button
            className="secondary-btn"
            onClick={()=>navigate('/employer')}
          >
            Request Workers
          </button>

        </div>

      </section>

    </div>

  );

}

export default ContactPage;